import React, { useEffect, useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Swal from 'sweetalert2';
import ViewImageAndText from '../../components/ViewImageAndText';
import { CModal } from '@coreui/react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceCommonFileUpload } from '../../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import { cleanHtml, Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';
import CkEditorField from '../../components/CkEditorField';

const InstituteUpdateCompetitiveExam = () => {
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload()
    const [questions, setQuestion] = useState([]);
    const [editId, setEditId] = useState(null);
    const [competitiveExamList, setCompetitiveExamList] = useState([]);
    const [subjectList, setSubjectList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [bookList, setBookList] = useState([])
    const [visible, setVisible] = useState(false)
    const [modalData, setModalData] = useState("")
    const navigate = useNavigate();

    const initialFormState = {
        q_level: '',
        q_type: '',
        question: '',
        option_a: '',
        option_b: '',
        option_c: '',
        option_d: '',
        ans: '',
        sol: ''
    }

    const initialFilterState = {
        instituteCompetitiveExamNameMasterId: '',
        instituteCompetitiveExamBookMasterId: '',
        instituteCompetitiveLessonMasterId: '',
        instituteCompetitiveTopicMasterId: '',
        instituteCompetitiveSubTopicMasterId: '',
        instituteSubjectMasterId: ''
    }

    const [filter, setFilter] = useState(initialFilterState);
    const [editAns, setEditAns] = useState(initialFormState);
    const [visibleImage, setVisibleImage] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [questionLevelSort, setQuestionLevelSort] = useState(null);
    const [questionTypeSort, setQuestionTypeSort] = useState(null);
    const [questionSort, setQuestionSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["q_level", "q_type", "question", "option_a", "option_b", "option_c", "option_d", "ans"];

    const [loading, setLoading] = useState(false);
    const handleNavigate = (route) => {
        navigate(route);
    };

    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getQuestionAnswerList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setQuestion(await searchArray("I", getApiUrl(), searchKeys, searchValue.trim(), "data"))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(questions, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(questions.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > questions.length) {
            endIndex = questions.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(questions.slice(startIndex, endIndex));
    }, [questions, currPage, itemsPerPage]);

    useEffect(() => {
        if (filter.instituteCompetitiveExamNameMasterId.length !== 0 && filter.instituteCompetitiveExamBookMasterId.length !== 0 && filter.instituteSubjectMasterId.length !== 0) {
            getQuestionAnswerList();
        }
    }, [filter]);

    const getApiUrl = () => {
        let apiUrl = `/get-institute-competitive-question-bank?instituteMasterId=${instituteMasterId}&`;
        if (filter.instituteCompetitiveExamNameMasterId) {
            apiUrl += `instituteCompetitiveExamNameMasterId=${filter.instituteCompetitiveExamNameMasterId}&`;
        }
        if (filter.instituteCompetitiveExamBookMasterId) {
            apiUrl += `instituteCompetitiveExamBookMasterId=${filter.instituteCompetitiveExamBookMasterId}&`
        }
        if (filter.instituteCompetitiveLessonMasterId) {
            apiUrl += `instituteCompetitiveLessonMasterId=${filter.instituteCompetitiveLessonMasterId}&`;
        }
        if (filter.instituteCompetitiveTopicMasterId) {
            apiUrl += `instituteCompetitiveTopicMasterId=${filter.instituteCompetitiveTopicMasterId}&`;
        }
        if (filter.instituteCompetitiveSubTopicMasterId) {
            apiUrl += `instituteCompetitiveSubTopicMasterId=${filter.instituteCompetitiveSubTopicMasterId}&`;
        }
        if (filter.instituteSubjectMasterId) {
            apiUrl += `instituteSubjectMasterId=${filter.instituteSubjectMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getQuestionAnswerList = async () => {
        if (filter.instituteCompetitiveExamNameMasterId.length !== 0 && filter.instituteCompetitiveExamBookMasterId.length !== 0 && filter.instituteSubjectMasterId.length !== 0) {
            try {
                const response = await authorizedAxiosInstitute.get(getApiUrl());
                setQuestion(response.data.data)
            } catch (error) {
                setQuestion([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-institute-competitive-exam-names?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setCompetitiveExamList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputFilterChange = (e) => {
        const { name, value } = e.target;
        setFilter((prevData) => {
            return {
                ...prevData,
                [name]: value
            }
        })
    }

    const handleSyllabusChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteCompetitiveExamBookMasterId: '',
                instituteSubjectMasterId: '',
                instituteCompetitiveLessonMasterId: '',
                instituteCompetitiveTopicMasterId: '',
                instituteCompetitiveSubTopicMasterId: ''
            }
        })

        const apiUrl2 = `/get-institute-competitive-exam-book-master?instituteCompetitiveExamNameMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
            .then(response => {
                setBookList(response.data.data)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleBookChanges = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteSubjectMasterId: '',
                instituteCompetitiveLessonMasterId: '',
                instituteCompetitiveTopicMasterId: '',
                instituteCompetitiveSubTopicMasterId: ''
            }
        })

        const apiUrl2 = `/get-institute-competitive-exam-book-wise-subject?instituteCompetitiveExamBookMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChanges = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteCompetitiveLessonMasterId: '',
                instituteCompetitiveTopicMasterId: '',
                instituteCompetitiveSubTopicMasterId: ''
            }
        })

        const apiUrl = `/get-institute-competitive-lesson-master?instituteMasterId=${instituteMasterId}&instituteCompetitiveExamBookMasterId=${filter.instituteCompetitiveExamBookMasterId}&instituteSubjectMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                setLessonList(error?.response?.data.result);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleLessonChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteCompetitiveTopicMasterId: '',
                instituteCompetitiveSubTopicMasterId: ''
            }
        })
        const apiUrl = `/get-institute-competitive-topic-master?instituteMasterId${instituteMasterId}&instituteCompetitiveLessonMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleTopicChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteCompetitiveSubTopicMasterId: ''
            }
        })
        const apiUrl = `/get-institute-competitive-sub-topic-master?instituteMasterId=${instituteMasterId}&instituteCompetitiveExamNameMasterId=${filter.instituteCompetitiveExamNameMasterId}&instituteCompetitiveExamBookMasterId=${filter.instituteCompetitiveExamBookMasterId}&instituteCompetitiveLessonMasterId=${filter.instituteCompetitiveLessonMasterId}&instituteCompetitiveTopicMasterId=${filter.instituteCompetitiveTopicMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setSubtopicList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setEditAns((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const deleteSubtopic = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-institute-competitive-question-bank?id=${id}`;
                const response = await authorizedAxiosInstitute.delete(apiUrl)
                const page = deleteItem(currPage, itemsPerPage, questions.length);
                await getQuestionAnswerList();
                setCurrPage(page);
                setEditAns(initialFormState)

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    // const cleanHtml = (html) => {
    //     return html
    //         ?.replace(/^<p>(.*?)<\/p>$/s, '$1')  // Remove outer <p> tags
    //         .replace(/&nbsp;/g, ' ')             // Replace non-breaking spaces
    //         .trim();                             // Trim whitespace
    // };

    const updateSubtopic = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-institute-competitive-question-bank?id=${editId}`;

            const fieldsToClean = ['question', 'option_a', 'option_b', 'option_c', 'option_d', 'sol'];
            const cleanedFields = {};

            fieldsToClean.forEach(field => {
                cleanedFields[field] = cleanHtml(editAns[field] || '');
            });

            const payload = {
                ...editAns,
                ...cleanedFields
            };

            const response = await authorizedAxiosInstitute.put(apiUrl, payload)
            await getQuestionAnswerList();
            setEditAns(initialFormState)
            setEditId(null);

            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    const handleCkChange = (fieldName, editor) => {
        const value = editor.getData();
        setEditAns((prev) => ({
            ...prev,
            [fieldName]: value
        }));
    };

    function uploadAdapter(loader) {
        return {
            upload: () => {
                return new Promise((resolve, reject) => {
                    const body = new FormData();
                    setLoading(true);
                    loader.file.then(async (file) => {
                        body.append("file", file);
                        const apiUrl = "uploadimage";
                        authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                            .then((res) => {
                                resolve({ default: res.data.result });
                            })
                            .catch((err) => {
                                reject(err?.response?.data?.error);
                            })
                            .finally(() => {
                                setLoading(false); // End loading
                            });
                    });
                });
            },
        };
    }

    function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
            return uploadAdapter(loader);
        };
    }

    const handleDetailChange = (editor) => {
        let value = editor.getData();
        setEditAns((prevData) => {
            return {
                ...prevData,
                sol: value
            }
        })
    }

    const handleReset = () => {
        setFilter(initialFilterState);
        setEditAns(initialFormState);
        setEditId(null);
        setBookList([]);
        setSubjectList([]);
        setLessonList([]);
        setTopicList([]);
        setSubtopicList([]);
        setQuestion([]);
        setVisible(false);
        setVisibleImage(false);
        setCurrPage(1);
        setItemsPerPage(10);
        setStartIndex(null);
        setTotalPages(0);
        setQuestionLevelSort(null);
        setQuestionTypeSort(null);
        setQuestionSort(null);
    }

    useEffect(() => {
        if (questionLevelSort == true || questionLevelSort == false) {
            setQuestionTypeSort(null);
            setQuestionSort(null);
        }
    }, [questionLevelSort])

    useEffect(() => {
        if (questionTypeSort == true || questionTypeSort == false) {
            setQuestionLevelSort(null);
            setQuestionSort(null);
        }
    }, [questionTypeSort])

    useEffect(() => {
        if (questionSort == true || questionSort == false) {
            setQuestionLevelSort(null);
            setQuestionTypeSort(null);
        }
    }, [questionSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Update Competitive Question Bank</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-eye"></i>Update Competitive Question Bank</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Competitive Exam  Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteCompetitiveExamNameMasterId' onChange={handleSyllabusChange} value={filter.instituteCompetitiveExamNameMasterId}>
                                                        <option selected value={''} disabled>Select Competitive Exam  Structure</option>
                                                        {
                                                            competitiveExamList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.examName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Book :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteCompetitiveExamBookMasterId' onChange={handleBookChanges} value={filter.instituteCompetitiveExamBookMasterId}>
                                                        <option selected value={''} disabled>Select Book</option>
                                                        {
                                                            bookList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.bookName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleSubjectChanges} value={filter.instituteSubjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.instituteSubjectMasterDetails.id}>{syllabus.instituteSubjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteCompetitiveLessonMasterId' onChange={handleLessonChange} value={filter.instituteCompetitiveLessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.competitiveLessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteCompetitiveTopicMasterId' onChange={handleTopicChange} value={filter.instituteCompetitiveTopicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.competitiveTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Sub Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitiveSubTopicName' onChange={handleInputFilterChange} value={filter.competitiveSubTopicName}>
                                                        <option selected value={''} disabled>Select Sub Topic</option>
                                                        {
                                                            subtopicList?.map((subtopic) => {
                                                                return <option value={subtopic.id}>{subtopic.competitiveSubTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                {!editId && <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={handleReset}>Reset</button>
                                                    </div>
                                                </div>}

                                                {editAns.question !== '' && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Question Level :</label>
                                                        <input required type="text" className="form-control" id="q_level" name='q_level' onChange={handleInputChange} value={editAns.q_level} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Question Type :</label>
                                                        <input required type="text" className="form-control" id="q_type" name='q_type' onChange={handleInputChange} value={editAns.q_type} />
                                                    </div>

                                                    {/* <div className='row'>
                                                        <div className="col-md-12">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Question :</label>
                                                            <input required type="text" className="form-control" id="question" name='question' onChange={handleInputChange} value={editAns.question} />
                                                        </div>
                                                    </div> */}
                                                    <CkEditorField label="Question" name="question" value={editAns.question} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />

                                                    {/* <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Option A :</label>
                                                            <input required type="text" className="form-control" id="option_a" name='option_a' onChange={handleInputChange} value={editAns.option_a} />
                                                        </div> */}
                                                    <CkEditorField label="Option A" name="option_a" value={editAns.option_a} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />

                                                    {/* <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Option B :</label>
                                                            <input required type="text" className="form-control" id="option_b" name='option_b' onChange={handleInputChange} value={editAns.option_b} />
                                                        </div> */}
                                                    <CkEditorField label="Option B" name="option_b" value={editAns.option_b} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />

                                                    {/* <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Option C :</label>
                                                            <input required type="text" className="form-control" id="option_c" name='option_c' onChange={handleInputChange} value={editAns.option_c} />
                                                        </div> */}
                                                    <CkEditorField label="Option C" name="option_c" value={editAns.option_c} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />

                                                    {/* <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Option D :</label>
                                                            <input required type="text" className="form-control" id="option_d" name='option_d' onChange={handleInputChange} value={editAns.option_d} />
                                                        </div> */}
                                                    <CkEditorField label="Option D" name="option_d" value={editAns.option_d} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />

                                                    <div className="col-md-12">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Answer :</label>
                                                        <input required type="text" className="form-control" id="ans" name='ans' onChange={handleInputChange} value={editAns.ans} />
                                                    </div>

                                                    {/* <div className="row">
                                                                <div className="col-md-12">
                                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Solution :</label>
                                                                    <CKEditor
                                                                        editor={ClassicEditor}
                                                                        data={editAns.sol}
                                                                        onReady={editor => {
                                                                            // You can store the "editor" and use when it is needed.
                                                                            // console.log('Editor is ready to use!', editor);
                                                                        }}
                                                                        onChange={(event, editor) => {
                                                                            // console.log(event)
                                                                            handleDetailChange(editor)
                                                                        }}

                                                                        config={{
                                                                            extraPlugins: [uploadPlugin],
                                                                        }}

                                                                        onInit={(editor) => {
                                                                            // Register the custom upload adapter
                                                                            uploadPlugin(editor);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div> */}
                                                    <CkEditorField label="Solution" name="sol" value={editAns.sol} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />



                                                    <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                        <div className="col-auto">
                                                            <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={() => updateSubtopic()} >Save</button>
                                                            <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => setEditAns(initialFormState)}>Reset</button>
                                                        </div>
                                                    </div>
                                                </>}

                                                {visible && <CModal
                                                    visible={visible}
                                                    onClose={() => setVisible(false)}
                                                    aria-labelledby="LiveDemoExampleLabel"
                                                    onIni
                                                >
                                                    <div className="book book-modal">
                                                        <h2 className='table-header-like'> Solution</h2>

                                                        <div className="page" dangerouslySetInnerHTML={{
                                                            __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${modalData}</div>`
                                                        }}></div>

                                                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                                                            Close
                                                        </button>
                                                    </div>
                                                </CModal>}

                                                {visibleImage && (
                                                    <CModal
                                                        visible={visibleImage}
                                                        onClose={() => setVisibleImage(false)}
                                                        aria-labelledby="LiveDemoExampleLabel"
                                                    >
                                                        <div className="book book-modal">
                                                            <div className='table-header-like'>Image</div>
                                                            {modalImageSrc && <div className='page' dangerouslySetInnerHTML={{ __html: modalImageSrc }}></div>}
                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisibleImage(false)}>
                                                                Close
                                                            </button>
                                                        </div>
                                                    </CModal>
                                                )}

                                                {filter.instituteSubjectMasterId !== "" &&
                                                    <div className="d-grid gap-2 mt-2">
                                                        <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                            <div className='search_btn_row'>
                                                                <input
                                                                    className="form-control mr-sm-2"
                                                                    type="Search"
                                                                    placeholder="Search"
                                                                    value={searchValue}
                                                                    onChange={handleEmptySearch}
                                                                    onKeyDown={(event) => {
                                                                        if (event.key === 'Enter') {
                                                                            handleSearch();
                                                                        }
                                                                    }}
                                                                />
                                                                <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                            </div>
                                                            <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope='col'>
                                                                                Q_Level
                                                                                <SortIcon sortState={questionLevelSort} setSortState={setQuestionLevelSort} setData={setQuestion} setCurrPage={setCurrPage} sortingPath={"q_level"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Q_Type
                                                                                <SortIcon sortState={questionTypeSort} setSortState={setQuestionTypeSort} setData={setQuestion} setCurrPage={setCurrPage} sortingPath={"q_type"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Question
                                                                                <SortIcon sortState={questionSort} setSortState={setQuestionSort} setData={setQuestion} setCurrPage={setCurrPage} sortingPath={"question"} />
                                                                            </th>
                                                                            <th scope="col">Option_a</th>
                                                                            <th scope="col">Option_b </th>
                                                                            <th scope="col">Option_c</th>
                                                                            <th scope="col">Option_d</th>
                                                                            <th scope='col'>Answer</th>
                                                                            <th scope='col'>Solution</th>
                                                                            <th scope='col'>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedData?.length > 0 ?
                                                                                displayedData?.map((question, index) => {
                                                                                    return (
                                                                                        <tr key={index}>
                                                                                            <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                            <td>{question.q_level}</td>
                                                                                            <td>{question.q_type}</td>
                                                                                            {/* <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_a} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_b} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_c} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_d} onViewImage={onViewImage} /> */}
                                                                                            <td><div dangerouslySetInnerHTML={{ __html: question.question }} /></td>
                                                                                            <td><div dangerouslySetInnerHTML={{ __html: question.option_a }} /></td>
                                                                                            <td><div dangerouslySetInnerHTML={{ __html: question.option_b }} /></td>
                                                                                            <td><div dangerouslySetInnerHTML={{ __html: question.option_c }} /></td>
                                                                                            <td><div dangerouslySetInnerHTML={{ __html: question.option_d }} /></td>
                                                                                            <td>{question.ans}</td>
                                                                                            <td>
                                                                                                <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                    setVisible(!visible)
                                                                                                    setModalData(question.sol)
                                                                                                }}><i class="fa fa-eye" ></i></button>
                                                                                            </td>
                                                                                            <td>
                                                                                                <button className="btn btn-outline-warning edit_icon" type="button" style={{ marginRight: '5px' }}
                                                                                                    onClick={() => {
                                                                                                        setEditId(question.id);
                                                                                                        setEditAns({
                                                                                                            q_level: question.q_level,
                                                                                                            q_type: question.q_type,
                                                                                                            question: question.question,
                                                                                                            option_a: question.option_a,
                                                                                                            option_b: question.option_b,
                                                                                                            option_c: question.option_c,
                                                                                                            option_d: question.option_d,
                                                                                                            ans: question.ans,
                                                                                                            sol: question.sol
                                                                                                        });
                                                                                                        document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                                    }}
                                                                                                ><i class="fa-light fa-pen-to-square"></i></button>
                                                                                                <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === question.id} onClick={() => deleteSubtopic(question.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                            </td>


                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={questions.length} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteUpdateCompetitiveExam;
